import * as React from "react";
import { Box, TextField } from "@mui/material";

export function ActivationInput({ activationCode, onActivationCodeChange, setSerialNumber,serialNumber }) {
    const formatSerialNumber = (value) => {
        const cleaned = value.replace(/[^\d-]/g, '');
        const matches = cleaned.match(/^.*\d{4}$/);
        if (matches) {
            if (cleaned.length<19){
                setSerialNumber(cleaned);
                return cleaned+'-';
            }
        }
        return cleaned;
    };

    const handleChange = (event) => {
        const value = event.target.value;
        const formattedValue = formatSerialNumber(value);
        if (formattedValue.length <= 20) {
            onActivationCodeChange(formattedValue);
        }
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Backspace' && activationCode.endsWith('-')) {
            event.preventDefault();
            onActivationCodeChange(activationCode.slice(0, -1));
        }
    };

    return (
        <Box
            sx={{
                display: 'flex',
                minHeight: '40px',
                width: '240px',
                maxWidth: '100%',
                flexDirection: 'column'
            }}
        >
            <TextField
                id="activationCode"
                value={activationCode}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                placeholder="XXXX-XXXX-XXXX-XXXX"
                variant="outlined"
                fullWidth
                inputProps={{
                    'aria-label': 'Activation Code',
                    maxLength: 19,
                    pattern: '[0-9]{4}-[0-9]{4}-[0-9]{4}-[0-9]{4}'
                }}
                sx={{
                    '& .MuiOutlinedInput-root': {
                        borderRadius: '8px',
                        backgroundColor: 'background.paper',
                        minWidth: '240px'
                    },
                    '& .MuiOutlinedInput-input': {
                        padding: '12px 16px',
                        textAlign: 'center',
                        letterSpacing: '2px',
                        fontFamily: 'monospace'
                    }
                }}
            />
        </Box>
    );
}